/*
 *
 * Gallery actions
 *
 */
import {
  FETCH_GALLERY_REQUEST,
  FETCH_GALLERY_SUCCESS,
  FETCH_GALLERY_FAILURE,
  DELETE_GALLERY_REQUEST,
  DELETE_GALLERY_SUCCESS,
  DELETE_GALLERY_FAILURE,
} from "./constants";

export const fetchGalleryRequest = ({ slug, params }) => ({
  type: FETCH_GALLERY_REQUEST,
  payload: {
    slug,
    params,
  },
});

export const fetchGallerySuccess = (payload) => ({
  type: FETCH_GALLERY_SUCCESS,
  payload,
});

export const fetchGalleryFailure = (error) => ({
  type: FETCH_GALLERY_FAILURE,
  error,
});

export const deleteGalleryRequest = (payload) => ({
  type: DELETE_GALLERY_REQUEST,
  gifId: payload,
});

export const deleteGallerySuccess = (payload) => ({
  type: DELETE_GALLERY_SUCCESS,
  payload,
});

export const deleteGalleryFailure = () => ({
  type: DELETE_GALLERY_FAILURE,
});
